const faqs = [
  {
    question: "What is SNILINK?",
    answer:
      "SNILINK is a web service that allows you to shorten long URLs into shorter ones. These shortened links can be used in place of the original URLs, and will redirect users to the original destination.",
  },
  {
    question: "How do I use SNILINK?",
    answer:
      'To use SNILINK, simply paste a long URL into the input field on the home page, and click the "Shorten" button. The website will generate a shortened link, which you can copy and use wherever you like.',
  },
  {
    question: "How long are the shortened links?",
    answer:
      "The shortened links generated by SNILINK are typically around 7-8 characters long. However, the exact length may vary depending on the algorithm used to generate the link.",
  },
  {
    question: "Can I customize the shortened links?",
    answer:
      "No, at this time there is no option to customize the shortened links generated by SNILINK. The links are automatically generated by the system.",
  },
  {
    question: "Is SNILINK free to use?",
    answer:
      "Yes, SNILINK is completely free to use. There are no hidden fees or charges.",
  },
  {
    question: "Is there a limit to how many links I can shorten?",
    answer:
      "At this time, there is no limit to the number of links you can shorten with SNILINK. However, we reserve the right to impose limits in the future if necessary to ensure the stability and availability of the service.",
  },
];
export default faqs;
